import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import { string } from 'prop-types';
import propTypes from '@styled-system/prop-types';
import SvgIcon from '../utils/SvgIcon';
export default function GenericImageIcon(_ref) {
  let {
    name,
    href
  } = _ref,
      propsWith = _objectWithoutPropertiesLoose(_ref, ["name", "href"]);

  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    "data-testid": `${name}Icon`
  }, propsWith), /*#__PURE__*/React.createElement("image", _extends({
    href: href
  }, propsWith)));
}
process.env.NODE_ENV !== "production" ? GenericImageIcon.propTypes = Object.assign({
  name: string,
  href: string,
  viewBox: string
}, propTypes.layout) : void 0;
GenericImageIcon.defaultProps = {
  x: 0,
  y: 0
};